export type StockSearchProduct = {
  active: boolean;
  name: string;
  sku?: string | null;
  plu?: string | null;
  fiskalproCode?: string | null;
};

function normalizeForSearch(value: string): string {
  return value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLocaleLowerCase("sk");
}

export function filterActiveStockProducts<T extends StockSearchProduct>(
  products: T[],
  search: string,
): T[] {
  const term = normalizeForSearch(search.trim());
  return products.filter((product) => {
    if (!product.active) return false;
    if (!term) return true;
    const searchable = [product.name, product.sku, product.plu, product.fiskalproCode]
      .filter((value): value is string => Boolean(value))
      .map(normalizeForSearch);
    return searchable.some((value) => value.includes(term));
  });
}
